interface PostPawapayErrorResponse {
    code: number;
    message: string;
}

export interface PostPaymantPawapayState {
    postPawapayData: any;
    loading: boolean;
    postPawapayErrorDara: PostPawapayErrorResponse | null;
}


export enum PostPaymantPawapayActionTypes {
    POST_PAWAPAY_PAYMENT_DATA = "POST_PAWAPAY_PAYMENT_DATA",
    POST_PAWAPAY_PAYMENT_DATA_SUCCESS = "POST_PAWAPAY_PAYMENT_DATA_SUCCESS",
    POST_PAWAPAY_PAYMENT_DATA_ERROR = "POST_PAWAPAY_PAYMENT_DATA_ERROR",
}

export type PostPaymantPawapayAction =
    | { type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA }
    | { type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_SUCCESS; payload: any }
    | { type: PostPaymantPawapayActionTypes.POST_PAWAPAY_PAYMENT_DATA_ERROR; payload: any };